/*
 * Copyright (c) 2023-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';

class OutputList extends Component {
    render() {
        let {children} = this.props

        return (
            <div className="overflow-hidden bg-white shadow rounded border">
                <div className=" px-4 py-5 sm:p-0 ">
                    <dl className="sm:divide-y sm:divide-gray-200 ">
                        {children}

                    </dl>
                </div>
            </div>

        );
    }
}

OutputList.propTypes = {};

export default OutputList;